import { stats, siteMeta } from '@/mocks/content';

export default function StatsSection() {
  return (
    <section className="py-12 md:py-16">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl mx-auto rounded-lg border border-background-200 bg-primary-50/70 overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-5">
            <div className="lg:col-span-2 p-6 md:p-8">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                {siteMeta.tagline}
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                我们把内容按题材归类、按热度排序、按主题串联，让「随便看看」和「想找某一类」这两种浏览方式都能各得其所。
              </p>
              <a
                href="#guide"
                className="mt-5 inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium rounded-md bg-accent-500 text-background-50 cursor-pointer whitespace-nowrap transition-colors hover:bg-accent-600"
              >
                <i className="ri-compass-line"></i>
                查看浏览指南
              </a>
            </div>
            <div className="lg:col-span-3 grid grid-cols-2 md:grid-cols-4 divide-x divide-y divide-background-200 border-t lg:border-t-0 lg:border-l border-background-200">
              {stats.map((s) => (
                <div key={s.label} className="p-5 md:p-6 text-center">
                  <div className="font-heading text-2xl md:text-3xl font-bold text-primary-600">{s.value}</div>
                  <div className="mt-1.5 text-sm font-medium text-foreground-800">{s.label}</div>
                  <div className="mt-1 text-xs text-foreground-500">{s.sub}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}